import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Ticktap Pay"
              description="TICKTAP PAY is a mobile e-wallet that aims to transform the way consumers transact on a daily basis. Tick Tap Pay App allows its users to simplify the payment process. Ticktappay is a secure and rewarding lifestyle e-wallet app. Our mission is to provide everyone with a worry-free cashless mobile payment experience all day every day. We aim to create a new generation of individuals to regain control of their financial freedom and rediscover value in financial services."
              ghLink="https://play.google.com/store/apps/details?id=com.ticktappay&pcampaignid=web_share"
              // demoLink="https://chatify-49.web.app/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="Luby Pay"
              description="LubyPay is a mobile e-wallet that aims to transform the way consumers transact on a daily basis. Luby Pay App allows its users to simplify the payment process. LubyPay is a secure and rewarding lifestyle e-wallet app. Our mission is to provide everyone with a worry-free cashless mobile payment experience all day every day. We aim to create a new generation of individuals to regain control of their financial freedom and rediscover value in financial services."
              // ghLink="https://github.com/singhsabh335/lungisha-main"
              ghLink="https://play.google.com/store/apps/details?id=com.lubypay&pcampaignid=web_share"

              // demoLink="https://blogs.soumya-jit.tech/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={leaf}
              isBlog={true}
              title="Mobile Gallary App"
              description="The Mobile Gallery App is a feature-rich application designed to help users organize, view, and manage their photos and videos seamlessly. The app includes functionalities like creating custom albums, tagging images, and searching by keywords or metadata. It also supports features like photo editing, sharing directly to social media, and offline access. The user-friendly interface ensures effortless navigation, while the app's robust performance makes it suitable for handling large media libraries efficiently."
              ghLink="https://github.com/singhsabh335/GalleryApp-main-Ashish"
              // demoLink="https://plant49-ai.herokuapp.com/"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="Astrochats"
              description="Get the right direction for every confusion with Astrochat.com! First chat 100% FREE.
Astrochat.com is your one-stop destination for astrology. Get answers on love, marriage, career, health, or financial future from our experienced astrologers with personalized guidance and remedies.
Join 1 lakh+ satisfied users and connect anytime, anywhere with certified astrologers from across India!
"
              ghLink="https://play.google.com/store/apps/details?id=com.peoplegroup.astrouser&pcampaignid=web_share"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={true}
              title="Ticktap mPOS"
              description="The Tacktap mPOS App is an all-in-one mobile point-of-sale solution designed to simplify and secure transactions for businesses of all sizes. With its compact and portable design, the app allows merchants to accept payments anytime, anywhere, offering unmatched convenience and efficiency.

                Whether you’re running a small retail shop, a food truck, or a large enterprise, the Tap and Pay mPOS App supports a variety of payment methods, including contactless NFC, QR codes, and popular digital wallets like Google Pay, Apple Pay, and Samsung Pay.

                 Key features ability to process refunds and void transactions effortlessly. The app ensures every transaction is secure advanced user authentication via PIN, password, or biometrics."
              ghLink="https://github.com/singhsabh335/FirstName_LastName"
              // demoLink="https://editor.soumya-jit.tech/"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
